import { useContext, useEffect, useState } from 'react'
import { GrFormClose } from 'react-icons/gr'
import { ModalTotalContext } from '../../../context/ModalContext'
import { BackgroundModal, ButtonExit, CloseContainer, ContainerModal, TitleModal } from './style'

const ModalAddProduct = ({ children, title, width, height, noClose, minWidth, minHeight }) => {
  const { setOpenModal } = useContext(ModalTotalContext)
  const [open, setopen] = useState(false)

  const handleClose = () => {
    setopen(false)
    setTimeout(() => {
      setOpenModal(null)
    }, 300)
  }
  useEffect(() => {
    setopen(true)
  }, [])
  return (
    <>
      <BackgroundModal show={open}>
        <ContainerModal
          width={width}
          height={height}
          minWidth={minWidth}
          minHeight={minHeight}
          className={open ? 'active' : null}
        >
          {!noClose && (
            <CloseContainer>
              <ButtonExit type="button" onClick={() => handleClose()}>
                <GrFormClose> </GrFormClose>
              </ButtonExit>
            </CloseContainer>
          )}
          <TitleModal>{title}</TitleModal>

          {children}
        </ContainerModal>
      </BackgroundModal>
    </>
  )
}
export default ModalAddProduct
